import {
    CALL_AVERAGE_PRACT_SUCCESS,
    CALL_AVERAGE_PRACT_FAIL,
    SET_MESSAGE,
    CALL_AVERAGE_PRACT_PENDING,
  } from "../types";
  import UserService from "../../services/user.service";
  import { toast } from "react-toastify";
  
  export const getCallAveragPractice = (body) => async (dispatch) => {
    dispatch({
      type: CALL_AVERAGE_PRACT_PENDING,
      payload: { callAvgPract: "isLoading" },
    });
    return await UserService.getCallAvgPract(body)
      .then(
        (data) => {
          data.data.status
            ? dispatch({
                type: CALL_AVERAGE_PRACT_SUCCESS,
                payload: { callAvgPract: data.data.result[0] },
              })
            : dispatch({
                type: CALL_AVERAGE_PRACT_FAIL,
              });
          return Promise.resolve();
        },
        (error) => {
          console.log("error......", error);
          const message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
  
          dispatch({
            type: CALL_AVERAGE_PRACT_FAIL,
          });
  
          dispatch({
            type: SET_MESSAGE,
            payload: message,
          });
  
          return Promise.reject();
        }
      )
      .catch((error) => {
        console.log(error);
      });
  };
  